const $body = document.querySelector('body');
let scrollPosition = 0;

const isEnabled = () => $body.style.overflow === 'hidden';

export default {
	enable() {
		scrollPosition = window.pageYOffset;
		$body.style.overflow = 'hidden';
		$body.style.position = 'fixed';
		$body.style.top = `-${scrollPosition}px`;
		$body.style.width = '100%';
		$body.classList.add("modal-open")
	},
	disable() {
		if (isEnabled()) {
			$body.style.removeProperty('overflow');
			$body.style.removeProperty('position');
			$body.style.removeProperty('top');
			$body.style.removeProperty('width');
			if($body.classList.contains("modal-open")){
				$body.classList.remove("modal-open");
			}
			window.scrollTo(0, scrollPosition);
		}
	},
	isEnabled,
};
